export default {
  manage_location: "Ubicaciones",
  manage_locationsTable_activated: "Activado",
  manage_locationsTable_deactivated: "Desactivado",
  manage_locationsTable_locationsTitle: "Ubicación del vehículo",
  manage_locationsTable_address: "Dirección",
  manage_locationsTable_enabledELDRule: "ELD 150 Millas Norma",
  manage_locationsTable_timezone: "Zona horaria",
  manage_locationsTable_unitsCount: "Unidades",
  manage_locationsTable_search_by_vehicle_location: "Buscar por ubicación del vehículo"
};
